export const semanticTokens = {
  colors: {
    'text-dimmed': {
      default: 'gray.500',
    },
  },
};
